<mat-grid-list cols="6" rowHeight="6:1" >
  <!-- Cabecera -->
  <mat-grid-tile [colspan]="6" >
    <h1>Cabecera</h1>
  </mat-grid-tile>

  <!-- Primera sección -->
  <mat-grid-tile  [colspan]="1">
    Sección 1
  </mat-grid-tile>

  <!-- Segunda sección -->
  <mat-grid-tile [colspan]="3" >
    Sección 2
  </mat-grid-tile>

  <!-- Tercera sección -->
  <mat-grid-tile [colspan]="2"  class="menu-derecho"  [colspan]="2">
   <mat-card appearance="outlined">
      <mat-card-content>

        <form [formGroup]="form">
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Titulo</mat-label>
                <input matInput type="text" maxlength="100" style="text-transform: uppercase"
                  formControlName="Titulo" />
                <mat-error *ngIf="form.controls['Titulo'].hasError('required')">Este campo es
                  <strong>requerido</strong>.</mat-error>
                <mat-error *ngIf="form.controls['Titulo'].hasError('maxlength')">Supero el largo maximo.</mat-error>
              </mat-form-field>
            </div>



            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Fecha vencimiento</mat-label>
                <input matInput [matDatepicker]="pickerFechaVencimiento" placeholder="MM/DD/YYYY"
                  formControlName="FechaVencimiento" />
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="pickerFechaVencimiento"></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaVencimiento></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <ngx-spinner [zIndex]="-1" name="spTipoTarea" bdColor="rgba(255,255,255,0.8)" size="small"
                  color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Tipo</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="IdTipoTarea">
                  <mat-option [value]="tipoTarea.id" *ngFor="let tipoTarea of tiposTarea">
                    {{ tipoTarea.descripcion }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls['IdTipoTarea'].hasError('required')">Este campo es
                  <strong>requerido</strong>.</mat-error>
              </mat-form-field>
            </div>

            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <ngx-spinner [zIndex]="-1" name="spEstadoTarea" bdColor="rgba(255,255,255,0.8)" size="small"
                  color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Estado</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="IdEstadoTarea">
                  <mat-option [value]="estadoTarea.id" *ngFor="let estadoTarea of estadosTarea">
                    {{ estadoTarea.descripcion }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls['IdEstadoTarea'].hasError('required')">Este campo es
                  <strong>requerido</strong>.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Fecha inicio estimada</mat-label>
                <input matInput [matDatepicker]="pickerFechaInicioEstimada" placeholder="MM/DD/YYYY"
                  formControlName="FechaInicioEstimada" />
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="pickerFechaInicioEstimada"></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaInicioEstimada></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Fecha inicio real</mat-label>
                <input matInput [matDatepicker]="pickerFechaInicioReal" placeholder="MM/DD/YYYY"
                  formControlName="FechaInicioReal" />
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="pickerFechaInicioReal"></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaInicioReal></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Nivel Avance</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="NivelAvance">
                  <mat-option [value]="nivel.id" *ngFor="
                let nivel of lstNiveles;
                let i = index;
                trackBy: trackByItems
              ">
                    {{ nivel.descripcion }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Prioridad</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="Prioridad">
                  <mat-option [value]="prioridad.id" *ngFor="
                let prioridad of lstPrioridades;
                let i = index;
                trackBy: trackByItems
              ">
                    {{ prioridad.descripcion }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline" class="w-100 col-lg-12">
                <mat-label>Descripcion</mat-label>
                <textarea matInput #message name="Descripcion" formControlName="Descripcion"></textarea>
                <mat-error *ngIf="form.controls['Descripcion'].hasError('required')">Este campo es
                  <strong>requerido</strong>.</mat-error>
                <mat-hint align="start">Amplie información</mat-hint>
                <mat-hint align="end">{{ message.value.length }} / 2000</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-grid-tile>


</mat-grid-list>
<mat-grid-list cols="6" rowHeight="6:1">
  <mat-grid-tile [colspan]="1" style="background-color: red;" >

  </mat-grid-tile>
<mat-grid-tile [colspan]="3" style="background-color: red;" >
    <h1>Pie</h1>
  </mat-grid-tile>
  <mat-grid-tile [colspan]="2" style="background-color: red;" >
    <h1>Pie</h1>
  </mat-grid-tile>

</mat-grid-list>


